import { render } from "./CometChatSenderAudioMessageBubble.vue?vue&type=template&id=6a8817c4&scoped=true"
import script from "./CometChatSenderAudioMessageBubble.vue?vue&type=script&lang=js"
export * from "./CometChatSenderAudioMessageBubble.vue?vue&type=script&lang=js"

import "./CometChatSenderAudioMessageBubble.vue?vue&type=style&index=0&id=6a8817c4&scoped=true&lang=css"
import "./CometChatSenderAudioMessageBubble.vue?vue&type=style&index=1&id=6a8817c4&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a8817c4"]])

export default __exports__